//
// Module for edit of service credit configuration
//
rs.module("system/configuration/servicecredit/edit",

    [
        "controls/components/event-banner",
        "common/select-helper",
        "common/visibility"
    ],

    function (eventBanner, selectHelper, visibility) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, columnIds, ajaxUrls, codeValues, isCreateMode) {

            // ensure errors are not cleared on postback,
            // only execute on selection
            var _executeServiceCreditRuleDetailsGridSelectionChanged;

            var configurationCard = $.js(jsSelectors.configurationCard);

            var serviceCalcRuleKey = configurationCard.js(jsSelectors.serviceCalcRuleKey);

            var detailCard = $.js(jsSelectors.detailCard);

            var addDetailButton = detailCard.js(jsSelectors.addDetailButton, { required: !isCreateMode });

            var detailUpdateToken = detailCard.js(jsSelectors.detailUpdateToken);
            var serviceCalcRuleDetailKey = detailCard.js(jsSelectors.serviceCalcRuleDetailKey);
            var parentServiceCalcRuleKey = detailCard.js(jsSelectors.parentServiceCalcRuleKey);

            var calculationMethodSelect = detailCard.js(jsSelectors.calculationMethodSelect);
            var calculationMethodSelectHelper = selectHelper.getHelper(calculationMethodSelect);

            var divisor = detailCard.js(jsSelectors.divisor);

            var tableNameSelect = detailCard.js(jsSelectors.tableNameSelect);
            var tableNameSelectHelper = selectHelper.getHelper(tableNameSelect);

            var newTableLink = detailCard.js(jsSelectors.newTableLink);

            var serviceClassificationsSelect = detailCard.js(jsSelectors.serviceClassificationsSelect);
            var serviceClassificationsSelectHelper = selectHelper.getHelper(serviceClassificationsSelect);

            var effectiveDate = detailCard.js(jsSelectors.effectiveDate);
            var terminationDate = detailCard.js(jsSelectors.terminationDate);
            var applyWorkPercent = detailCard.js(jsSelectors.applyWorkPercent);

            var cancelDetailButton = detailCard.js(jsSelectors.cancelDetailButton, { required: !isCreateMode });

            calculationMethodSelect.change(calculationMethodChanged);

            // enable/disable fields based on calculation method
            function calculationMethodChanged() {
                var isDivisorCalculationMethod = calculationMethodSelect.val() == codeValues.divisorCalculationMethod;
                if (!isDivisorCalculationMethod) {
                    divisor.clearErrors();
                    divisor.val('');
                }
                divisor.prop('disabled', !isDivisorCalculationMethod);

                var isFlatCalculationMethod = calculationMethodSelect.val() == codeValues.flatCalculationMethod;
                if (!isFlatCalculationMethod) {
                    tableNameSelect.clearErrors();
                    tableNameSelectHelper.setValue('');

                    visibility.hide(newTableLink);
                } else {
                    $.getJSON(ajaxUrls.getNewTableUrl,
                        { serviceCalcRuleKey: serviceCalcRuleKey.val(), serviceCalcRuleDetailKey: serviceCalcRuleDetailKey.val() },
                        function (data) {
                            newTableLink.prop('href', data.url);
                        });

                    visibility.show(newTableLink);
                }
                tableNameSelectHelper.setDisabled(!isFlatCalculationMethod);

                var isTimeElapsedCalculationMethod = calculationMethodSelect.val() == codeValues.timeElapsedCalculationMethod;
                if (isTimeElapsedCalculationMethod) {
                    applyWorkPercent.clearErrors();
                    applyWorkPercent.prop('checked', false);
                }
                applyWorkPercent.prop('disabled', isTimeElapsedCalculationMethod);
            }

            if (!isCreateMode) {

                // only call select function of lrsGridApi not on postback
                lrsGridApi.selectionChanged(function (values, rows) {
                    if (_executeServiceCreditRuleDetailsGridSelectionChanged && values.length > 0) {
                        OnServiceCreditRuleDetailsGridRowSelect(rows[0]);
                    }

                    _executeServiceCreditRuleDetailsGridSelectionChanged = true;
                });

                // when add of detail is clicked
                // clear errors and grid selection, default values
                addDetailButton.click(function () {
                    ClearErrorsAndInfoMessagesOfDetailForm();

                    lrsGridApi.selectedValues = null;

                    ClearOrDefaultFieldsOfDetailForm();
                });

                // reset grid selection
                cancelDetailButton.click(function () {
                    ResetServiceCreditRuleDetailsGridRowSelection();
                });

                // Either select the first row of the grid or manually clear related fields 
                function ResetServiceCreditRuleDetailsGridRowSelection() {
                    if (lrsGridApi.agGridApi.getDisplayedRowCount() == 0) {
                        // if no rows exist, call for clearing of errors and defaulting of fields that'd normally be called in select event
                        ClearErrorsAndInfoMessagesOfDetailForm();
                        ClearOrDefaultFieldsOfDetailForm();

                    } else if (lrsGridApi.agGridApi.getSelectedNodes().length && lrsGridApi.agGridApi.getSelectedNodes()[0].childIndex == 0) {
                        // if already on first row, selectionChanged won't be fired, so manually call select for row
                        OnServiceCreditRuleDetailsGridRowSelect(lrsGridApi.selectedRows[0]);

                    } else {
                        lrsGridApi.selectFirstRow();
                    }
                }

                // on selection of a detail grid row,
                // clear errors and messages and set fields for new selection
                function OnServiceCreditRuleDetailsGridRowSelect(selectedRow) {
                    ClearErrorsAndInfoMessagesOfDetailForm();

                    $.get(
                        ajaxUrls.getDetail,
                        { serviceCalcRuleDetailKey: selectedRow[columnIds.serviceCalcRuleDetailKeyColumnID] },

                        function (data) {
                            detailUpdateToken.val(data.updateToken);
                            serviceCalcRuleDetailKey.val(data.serviceCalcRuleDetailKey);
                            parentServiceCalcRuleKey.val(data.serviceCalcRuleKey);

                            calculationMethodSelectHelper.setValue(data.serviceCalcMethod.key);
                            calculationMethodSelect.change();

                            divisor.val(data.denominator);

                            tableNameSelectHelper.setValue(data.tableName);

                            var serviceClassifications = [];

                            if (data.benefitServiceFlag) { serviceClassifications.push('BenefitServiceFlag'); }
                            if (data.eligibilityServiceFlag) { serviceClassifications.push('EligibilityServiceFlag'); }
                            if (data.vestingServiceFlag) { serviceClassifications.push('VestingServiceFlag'); }

                            serviceClassificationsSelectHelper.setValue(serviceClassifications);

                            var effectiveDateFromResult = data.ruleEffectiveDate ? new Date(data.ruleEffectiveDate) : null;
                            var terminationDateFromResult = data.ruleTerminationDate ? new Date(data.ruleTerminationDate) : null;

                            effectiveDate.val(effectiveDateFromResult ? effectiveDateFromResult.toISODateString() : null);
                            terminationDate.val(terminationDateFromResult ? terminationDateFromResult.toISODateString() : null);

                            applyWorkPercent.prop('checked', data.applyWorkPercentFlag);
                        }
                    );
                }

                // clear messages and client validation of detail fields
                function ClearErrorsAndInfoMessagesOfDetailForm() {
                    eventBanner.removeAllMessages();

                    [
                        detailUpdateToken,
                        serviceCalcRuleDetailKey,
                        parentServiceCalcRuleKey,
                        calculationMethodSelect,
                        divisor,
                        tableNameSelect,
                        serviceClassificationsSelect,
                        effectiveDate,
                        terminationDate,
                        applyWorkPercent
                    ].forEach((input) => input.clearErrors());
                }

                // set the detail fields for Add
                function ClearOrDefaultFieldsOfDetailForm() {
                    serviceCalcRuleDetailKey.val('-1');
                    parentServiceCalcRuleKey.val(serviceCalcRuleKey.val());

                    calculationMethodSelectHelper.selectIndex(0);
                    calculationMethodSelect.change();

                    tableNameSelectHelper.selectIndex(0);
                    serviceClassificationsSelectHelper.setValue(null);

                    [
                        detailUpdateToken,
                        divisor,
                        effectiveDate,
                        terminationDate
                    ].forEach((input) => input.val(''));

                    applyWorkPercent.prop('checked', false);
                }

            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);